import jump from 'jump.js';
import formSerialize from 'form-serialize';
import debounce from '../../helpers/debounce';
import { rewriteHistory, getData } from './utils';
import fetchFromAPI from './api';

const $filter = $('.js-filters');
const $form = $('.js-filters-form');
const $options = $('.js-filters-options');
const $pagination = $('.js-filter-pagination');
const $remove = $('.js-filters-remove');
const $wrap = $('.js-filters-wrap');
const $pageInput = $('.js-filter-page');

const $overlay = $('.js-page-overlay');

const dataType = 'json';

const DEBOUNCE_VAL = 300;

const filter = {
  initialize() {
    this.filtersCombined = () => {
      this.runFilter();
    };

    const debouncedFilters = debounce(this.filtersCombined, DEBOUNCE_VAL);

    $form.add($options).on('change', 'input[type="checkbox"], input[type="radio"], select', () => {
      this.setPageNumber(1);
      this.filtersCombined();
    });

    $form.add($options).on('keyup', 'input[type="text"], input[type="search"], textarea', () => {
      this.setPageNumber(1);
      debouncedFilters();
    });

    $form.add($options).on('click', '.js-clear-date-select', () => {
      this.filtersCombined();
    });

    $pagination.on('click', 'a', (e) => {
      const $el = $(e.currentTarget);
      let page = $el.data('page');

      if (typeof page === 'undefined') {
        return true;
      }

      page = parseInt(page, 10);

      this.setPageNumber(page);
      this.filtersCombined();
      this.scrollToTop();

      return false;
    });

    $remove.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      $form.find('input[type="checkbox"], input[type="radio"]')
        .prop('checked', false)
        .removeAttr('checked');

      this.filtersCombined();
    });

    this.checkDisabledGroups();
  },

  closeDropdowns() {
    $form.find('.js-filter-dropdown').removeClass('is-visible');
    $('.js-filter-toggle').removeClass('is-open');
  },

  getPageNumber() {
    return parseInt($pageInput.val(), 10);
  },

  getApiUrl() {
    return getData($filter, 'filter-api', '');
  },

  getApiMethod() {
    return getData($filter, 'filter-api-method', 'POST');
  },

  setPageNumber(num) {
    $pageInput.val(num);
  },

  scrollToTop() {
    jump($wrap[0], {
      offset: -15,
      a11y: false,
      duration: 150,
    });
  },

  serializeElement(el) {
    const serialized = formSerialize(el, { hash: true });
    return serialized;
  },

  runFilter() {
    const filters = this.serializeElement($form[0]);
    const options = this.serializeElement($options[0]);
    const data = { ...filters, ...options };

    $overlay.addClass('is-visible');

    rewriteHistory(data);

    fetchFromAPI(this.getApiUrl(), this.getApiMethod(), data, dataType, (res) => {
      const $html = $(res);

      this.replaceContent($html);

      $overlay.removeClass('is-visible');
    });
  },

  replaceContent($html) {
    const $contentToReplace = $(document).find('[data-replace]');

    if ($contentToReplace.length) {
      $contentToReplace.each((i, content) => {
        const replaceId = content.getAttribute('data-replace');
        const $contentFromResponse = $html.find(`[data-replace="${replaceId}"]`);

        if ($contentFromResponse) {
          content.innerHTML = $contentFromResponse[0].innerHTML;
        }
      });
    }
  },

  checkDisabledGroups() {
    $('.js-filter-bar-item').each((i, item) => {
      const $checkboxes = $(item).find('input[type="checkbox"]:not(:disabled)');

      $(item).find('.js-filter-toggle').prop('disabled', (!$checkboxes.length));
    });
  },
};

export default filter;
